<template>
  <div>
    <div class="header">
      <span>대출 현황</span>
    </div>
    <div v-for="(item, i) in loans" :key="i">
      <v-card>
        <v-card-title>
          <span><span v-if="item.type === 'marketing'">마케팅론 </span>{{ item.offer.period_in_days }}일 상환 </span>
          <span>{{ status(item.left_amount) }}
            <v-btn :to="{ name: 'my/loansDetail', params: { uuid: item.uuid} }" icon>
              <img src="@/assets/icon/btn-btn-next-dn.svg" v-if="status(item.left_amount) === '상환중'"/>
              <img src="@/assets/images/btn-next.png" v-else/>
            </v-btn>
          </span>
        </v-card-title>
        <hr />
        <v-card-subtitle>
          <div class="amount">
            <strong>대출잔액 {{ item.left_amount | commaFormat }} 원</strong>
          </div>
        </v-card-subtitle>
      </v-card>
    </div>
  </div>
</template>
<script>
import LoanService from '@/service/loan/LoanService'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  props: ['loan'],
  data() {
    return {
      loans: [],
      leftAmount: 0,
      marketingCount: 0,
    }
  },
  async created() {
    await this.setMyLoans()
  },
  computed: {
    ...mapGetters('loan', {
      loan: 'getLoanData'
    }),
    status() {
      return leftAmount => leftAmount > 0 ? '상환중' : '상환완료'
    },
  },
  methods: {
    async setMyLoans() {
      let loans = await LoanService.getLoanOngoingForRepayment()
      console.log(loans)
      this.loans = loans.filter((loan) => loan.status === 'executed')
    }
  },
}
</script>
<style lang="scss" scoped>
  .header {
    margin-top: 25px;
    margin-bottom: 25px;
    span {
      font-size: 1.2rem;
      font-weight: 900;
      margin: 0 25px;
    }
  }
  .v-card {
    margin: 0 25px;
    margin-bottom: 20px;

    .theme--light.v-btn.v-btn--icon {
      color: #ffffff;
    }

    hr {
      color: #f2f2f2;
    }

    button img {
      width: 54%;
    }

    &__title {
      font-size: 1rem;
      justify-content: space-between;
      padding-right: 25px;
      padding-left: 25px;

      span {
        font-weight: 900;
      }
    }
    .v-card__subtitle {
      color: #333333;
      padding-top: 11px;
      padding-bottom: 11px;
      padding-right: 25px;
      padding-left: 25px;
      line-height: 25px;

      .amount {
        text-align: right;
        strong {
          font-size: 1rem;
          font-weight: 900;
          color: #333333;
        }
      }
    }

    .v-card__actions {
      padding: 0;
    }
  }
</style>
